import type { Comment } from '@/types';

const palette = ['bg-primary-500', 'bg-accent-500', 'bg-secondary-500', 'bg-foreground-700'];

const make = (dramaId: string, rows: [string, string, string, number][]): Comment[] =>
  rows.map((r, i) => ({
    id: `${dramaId}-c${i + 1}`,
    user: r[0],
    content: r[1],
    date: r[2],
    likes: r[3],
    avatarColor: palette[(dramaId.length + i) % palette.length],
  }));

export const dramaComments: Record<string, Comment[]> = {
  'seoul-nocturne': make('seoul-nocturne', [
    ['夜里听歌的人', '雨中告白那段我反反复复看了三遍，后劲太大了。', '2 天前', 128],
    ['首尔的风', '男女主的化学反应太好了，希望后面别烂尾。', '3 天前', 86],
    ['拿铁不加糖', '那首诗其实就是整部剧的线索吧，细思极恐。', '4 天前', 54],
  ]),
  'silent-testimony': make('silent-testimony', [
    ['推理爱好者', '声纹那条线铺得太妙了，第二集就埋了伏笔。', '1 周前', 231],
    ['熬夜追剧', '宋康昊的眼神戏不用台词都能吓到我。', '1 周前', 187],
    ['真相只有一个', '结局没有强行圆满，反而更真实，加分。', '2 周前', 142],
  ]),
  'shadow-throne': make('shadow-throne', [
    ['史剧控', '服化道太用心了，每一帧都能截下来做壁纸。', '5 天前', 176],
    ['朝堂观察员', '女官那盘棋是真的高，编剧懂权谋。', '6 天前', 99],
    ['意难平', '开放式结局让我一整晚没睡着。', '1 周前', 205],
  ]),
  'stardust-lovers': make('stardust-lovers', [
    ['看星星的人', '奇幻题材拍得这么温柔，太治愈了。', '2 天前', 74],
    ['流星猎人', '三个名字的设定很有意思，期待揭晓。', '3 天前', 62],
  ]),
  'gangnam-cafe': make('gangnam-cafe', [
    ['咖啡续命', '下班之后看这个剧，整个人都放松了。', '1 周前', 88],
    ['小巷常客', '群像写得好，每个配角都可爱。', '2 周前', 51],
  ]),
  'echoes-abyss': make('echoes-abyss', [
    ['深海恐惧症', '水下那一段我全程屏住呼吸，太吓人了。', '1 天前', 143],
    ['悬疑上头', '声音设计满分，安静的时候最可怕。', '2 天前', 97],
    ['理性分析', '那行刻字的逻辑很严谨，不像硬凑的。', '3 天前', 70],
  ]),
  'star-goryeo': make('star-goryeo', [
    ['家国情怀', '战场戏拍出了大银幕的质感，热血。', '3 周前', 118],
    ['雪落无声', '第一场雪那集太好哭了。', '1 个月前', 83],
  ]),
  'our-summer': make('our-summer', [
    ['青春已远', '草稿纸背面那段，瞬间拉回高中时代。', '1 周前', 165],
    ['随身听', 'OST 也太好听了，已经在循环。', '2 周前', 92],
  ]),
  'chaebol-tutor': make('chaebol-tutor', [
    ['爽文男友', '第三集管家说漏嘴那里，我直接坐直了。', '4 天前', 79],
    ['都市打工人', '一边爽一边笑，解压神剧。', '5 天前', 44],
  ]),
  'moonlight-hospital': make('moonlight-hospital', [
    ['白衣天使', '发不出工资还没人走，这段真的戳到我了。', '2 周前', 134],
    ['天台风景', '男女主的感情线很克制，反而更动人。', '3 周前', 76],
  ]),
  'memory-maze': make('memory-maze', [
    ['烧脑爱好者', '建议画时间线来看，信息量太大了。', '1 天前', 208],
    ['镜中人', '当你开始怀疑主角是否存在，剧就成了。', '2 天前', 156],
    ['科幻迷', '冷蓝暖橙的色彩区分很聪明。', '4 天前', 88],
  ]),
  'camellias-bloom': make('camellias-bloom', [
    ['想家了', '看一集哭一集，妈妈那段的表演太真实。', '1 个月前', 245],
    ['山茶花', '群像做得像纪录片，每一个角色都有血有肉。', '1 个月前', 192],
    ['旧信', '一柜旧信那条线是我最爱的部分。', '2 个月前', 121],
  ]),
};